import { createApp } from 'utils/vue';
import App from "components/pages/usersettings/change_password";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App).mount("#app-container");
};

registerHandler("usersettings/changepassword", handler);
